var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('div',{staticClass:"tag is-medium has-tooltip-left",class:_vm.tagClass,attrs:{"data-tooltip":_vm.tooltip}},[_vm._v(" "+_vm._s(_vm.$t('statuses_' + _vm.status))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }